import WebApi from './WebApi';

export class AdvertiserService {
  static async searchClients(search, token) {
    const response = await WebApi.get('/anunciantes', {
      Busca: search,
      Tipo: 'C',
      Login: token.profile.sub
    });
    return response.data;
  }

  static async searchAgencies(search, token) {
    const response = await WebApi.get('/anunciantes', {
      Busca: search,
      Tipo: 'A',
      Login: token.profile.sub
    });
    return response.data;
  }

  static async saveClient(cnpj, agency, paymentType, token, totalAmount, beginDate, endDate) {
    const response = await WebApi.post('/anunciantes', {
      Cnpj: cnpj,
      Agencias: agency.map(ag => { return {
        Id: ag.id,
        Nome: ag.nome,
        Cnpj: ag.cnpj || ag.cpf
      }}),
      Login: token.profile.sub,
      TipoFaturamento: paymentType,
      Valor: totalAmount,
      DataInicio: beginDate,
      DataFim: endDate
    });
    return response.data;
  }
}
